import { IDataSourceApiService, IEntity, IEntityMetadata, INamespace } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

export const InveniasMockNamespace: INamespace = { name: 'invenias-mock' };

export class InveniasMockDatasourceApiService implements IDataSourceApiService {
  get(entity: IEntity, getParams?: any): Observable<any> {
    const r = entityDb.find((e) => e.id === entity.id && e.type === entity.type);
    return of(r);
  }

  query(entityType: any, queryParams: any): Observable<any[]> {
    const entities = entityDb.filter((e) => e.type === entityType && e.name.indexOf(queryParams) > -1);
    return of(entities);
  }

  list(listParams: any): Observable<any[]> {
    const entities = entityDb.filter((e) => e.type === listParams.entity.type && e.id === listParams.entity.id);
    const items: any[] = [];
    if (listParams.associatedType) {
      entities.forEach((e) => items.push(...(e as any)[listParams.associatedType]));
    }
    return of(items);
  }

  ping(): Observable<boolean> {
    return of(true);
  }

  meta(): Observable<IEntityMetadata[]> {
    return of([
      {
        name: 'peopleListItem',
        label: 'Person',
      },
      {
        name: 'companiesListItem',
        label: 'Company',
      },
      {
        name: 'assignmentsListItem',
        label: 'Assignment',
      },
      {
        name: 'programmesListItem',
        label: 'Programme',
      },
    ]);
  }

  settings(settings: string): Observable<any> {
    return of({});
  }

  buildApiUrl(path: string): string {
    return path;
  }
}

const entityDb = [
  { id: '1', type: 'document', name: 'test.pdf' },
  { id: '2', type: 'document', name: 'my-document.docx' },
  { id: '1', type: 'people', name: 'BW', documents: [{ name: 'test.pdf' }] },
  {
    id: '2',
    type: 'people',
    name: 'AJ',
    documents: [{ name: 'advanced-css.pdf' }],
  },
  {
    id: '3',
    type: 'people',
    name: 'Davros',
    documents: [
      { id: 1, name: 'test.pdf' },
      { id: 2, name: 'my-document.docx' },
      { id: 3, name: 'mooncake.jpg' },
      { id: 4, name: 'data.xslx' },
    ],
  },
  { id: '4', type: 'people', name: 'Barrington', documents: [] },
  {
    id: '5',
    type: 'people',
    name: 'Barry',
    documents: [
      { id: 1, name: 'helloworld.ts' },
      { id: 2, name: 'SOLID-code.pdf' },
    ],
  },
  { id: '6', type: 'people', name: 'Davina', documents: [] },
  {
    id: '1',
    type: 'companies',
    name: 'Mega-Corp1',
    documents: [{ id: 1, name: 'beginners-guide-to-global-domination.docx' }],
  },
  { id: '2', type: 'companies', name: 'Massive Dynamics', documents: [] },
];
